import { useSelectedLayoutSegments } from 'next/navigation';

/**
 * Note that this only behaves as expected when used in components in the root explore layout.
 * Do not attempt to use this in components used in page files below the root explore layout.
 */
const useIsPage = () => {
  const sections = useSelectedLayoutSegments();

  const isSegment = (index: number, segment: string) => sections?.[index] === segment;
  const hasSections = sections && sections.length >= 2;
  const isExplore = hasSections && isSegment(1, 'explore');

  const isExploreRoot = isExplore && sections.length === 2;
  const isExplorePOI = isExplore && isSegment(2, 'poi');
  const isExplorePark = isExplore && isSegment(2, 'parks');
  const isExploreTrail = isExplore && isSegment(2, 'trail');
  const isExploreRecentlyViewed = isExplore && isSegment(2, 'recently-viewed');
  const isCustomRoute = isExplore && isSegment(2, 'custom-routes');
  const isNewCustomRoute = isCustomRoute && (isSegment(3, 'new') || isSegment(3, 'trail'));
  const isSavedCustomRoute = isCustomRoute && !isNewCustomRoute;
  const isMembersCustomRoute = hasSections && isSegment(1, 'members') && isSegment(3, 'custom-routes');

  return {
    isExploreRoot,
    isExplorePOI,
    isExplorePark,
    isExploreTrail,
    isExploreRecentlyViewed,
    isCustomRoute,
    isNewCustomRoute,
    isSavedCustomRoute,
    isMembersCustomRoute
  };
};

export default useIsPage;
